module.exports = __webpack_public_path__ + "static/media/slideshow2.13281508.jpg";